import { ChildModel, ModelBase } from 'store/model-base';
import { LineTransfer } from './line-transfer';

export class LineTransferCollection extends ModelBase {
    public static storeName: string = 'lineTransferCollection';
    
    public lineTransfers: LineTransfer[];
    public accountIdKey: string;

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        return super.create<T>(data);
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'lineTransfers',
            model: LineTransfer
        }];
    }
}
